import { NgModule, inject } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicModule } from '@ionic/angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { AppTranslateService } from './services/translate.service';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Router, RouterModule } from '@angular/router';

import { provideFirebaseApp, initializeApp as initializeFirebaseApp, getApp } from '@angular/fire/app';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideAuth } from '@angular/fire/auth';

import { initializeAuth, indexedDBLocalPersistence, getAuth as getWebAuth, browserPopupRedirectResolver } from 'firebase/auth';
import { environment } from '../environments/environment';
import { setLogLevel, LogLevel } from '@angular/fire';
import { Capacitor } from '@capacitor/core';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: { provide: TranslateLoader, useFactory: HttpLoaderFactory, deps: [HttpClient] }
    }),
  ],
  providers: [
    provideFirebaseApp(() => initializeFirebaseApp(environment.firebaseConfig)),

    // Ensure Firestore is the normal web SDK instance
    provideFirestore(() => getFirestore()),

    // IMPORTANT: Initialize Auth with IndexedDB persistence for WKWebView
    provideAuth(() => {
      const app = getApp();
      try {
        // On native (Capacitor) platforms we should not attach the browser popup resolver
        // because WKWebView/Cordova/Capacitor environments handle native SSO differently.
        // For web, include the browser popup resolver so popup-based SSO works.
        // Note: Keep indexedDB persistence for WKWebView compatibility.
        if (typeof Capacitor !== 'undefined' && Capacitor.isNativePlatform && Capacitor.isNativePlatform()) {
          return initializeAuth(app, { persistence: indexedDBLocalPersistence });
        }
        return initializeAuth(app, { persistence: indexedDBLocalPersistence, popupRedirectResolver: browserPopupRedirectResolver });
      } catch {
        // If already initialized (e.g., HMR), fall back to the default getter
        return getWebAuth(app);
      }
    }),
    AppTranslateService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {
    setLogLevel(LogLevel.SILENT);
  }
}
